import { useEffect } from 'react';
import { getPlans } from 'State/Plans';
import { useSubscription } from 'Hooks/useSubscription';
import { useStore } from './useStore';

/*
  Handles:
  1) getting plans with strings/image from DPP. The plans will include:
    a) selectable plans
    b) existing plan (if current subscribeer)
    c) next plan (if exists. "nextSubscription", which is a plan that was purchased but
       isn't active until after the active subscription expires)
  2) preselecting plan - preSelectedPlan can be the planId or the start of the displayName
*/

export const usePlans = (preSelectedPlan = '', pathname = '') => {
  const { isFetching, isFetchingStatus, isStatusSuccess, isSuccess } = useSubscription();
  const isAuthenticated = useStore('user.isAuthenticated');
  const plans = useStore('plans');
  const routes = useStore('appConfig.routes');

  useEffect(() => {
    // do not run `getPlans()` from this hook on pages that already run `getPlans()` on their own
    // this helps prevent conflicts where requests may resolve out of order
    const excludedRoutes = [
      routes.sheerIdVerification,
      routes.payment,
      routes.signin,
      routes.signupPreSelectedPlan.split(':')[0], // logic already exists in the component to preselect the plan
      routes.callback, // also already called inside the component itself
    ];
    if (
      excludedRoutes.every((route) => !pathname.startsWith(route)) &&
      (!isAuthenticated || (isAuthenticated && !isFetchingStatus && !isFetching && isStatusSuccess && isSuccess))
    ) {
      getPlans(preSelectedPlan);
    }
  }, [isAuthenticated, isFetchingStatus, isFetching, isStatusSuccess, preSelectedPlan, isSuccess, pathname, routes]);

  return plans;
};
